// hooks/usePoolUpdate.js
import { useState } from 'react';
import { ApiUrl } from '../../../../utils/ApiUrl';

export const usePoolUpdate = () => {
    const [isUpdating, setIsUpdating] = useState(false);
    const [error, setError] = useState(null);

    const getAccessToken = () => {
        const token = localStorage.getItem('accessToken');
        if (!token) {
            throw new Error("Access token not found. Please login again.");
        }
        return token;
    };

    const makeApiCall = async (payload) => {
        try {
            setIsUpdating(true);
            setError(null);

            const accessToken = getAccessToken();

            const response = await fetch(`${ApiUrl}/pool`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error(`API error: ${response.statusText}`);
            }

            const data = await response.json();
            // console.log("Pool updated successfully:", data);
            setIsUpdating(false);
            return data;
        } catch (err) {
            console.error("Error updating pool:", err);
            setError(err.message);
            setIsUpdating(false);
            throw err;
        }
    };

    /**
     * Update pool reward amount
     * @param {string} poolId - Pool's _id
     * @param {number} newRewardAmount - New reward amount to add
     * @param {number} currentRewardAmount - Current reward amount in pool
     * @returns {Promise}
     */
    const updateRewardAmount = async (poolId, newRewardAmount, currentRewardAmount = 0) => {
        const totalRewardAmount = parseFloat(currentRewardAmount || 0) + parseFloat(newRewardAmount);

        const payload = {
            rewardAmount: totalRewardAmount,
            rootPoolId: poolId
        };

        return makeApiCall(payload);
    };

    /**
     * Update pool end date
     * @param {string} poolId - Pool's _id
     * @param {Date} newEndDate - New end date
     * @returns {Promise}
     */
    const updatePoolEndDate = async (poolId, newEndDate) => {
        const payload = {
            poolEndDate: newEndDate.toISOString(),
            rootPoolId: poolId
        };

        return makeApiCall(payload);
    };

    return {
        updateRewardAmount,
        updatePoolEndDate,
        isUpdating,
        error
    };
};